<template>
  <v-list-tile v-if="!isEditing" avatar ripple class="it-hv">
    <v-list-tile-avatar>
      <font-awesome-icon :icon="['fal', 'venus-mars']"></font-awesome-icon>
    </v-list-tile-avatar>
    <v-list-tile-content>
      <v-list-tile-sub-title class="caption" v-if="!isPrintEmpty">性別</v-list-tile-sub-title>
      <v-list-tile-title>{{ printSex }}</v-list-tile-title>
    </v-list-tile-content>
    <v-list-tile-action>
      <v-tooltip bottom>
        <v-btn flat icon slot="activator" class="blue--text text--darken-2" :loading="isThisLoading" @click="edit"><font-awesome-icon :icon="['fal', 'pencil']"/></v-btn>
        <span>編集する</span>
      </v-tooltip>
    </v-list-tile-action>
  </v-list-tile>
  <v-container v-else>
    <v-subheader>性別</v-subheader>
    <v-layout wrap class="pb-4">
      <v-flex xs12 class="px-3">
        <v-radio-group required row
          v-model="form.sex.content"
          :rules="rules.sex">
          <v-radio v-for="(item, key) in getSexItems" :key="key"
            color="blue darken-2"
            :label="item"
            :value="key"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
export default {
  name: 'clientAboutBasicSex',
  props: [
    'status',
    'data'
  ],
  data () {
    return {
      form: {
        sex: {
          id: '',
          content: ''
        }
      },
      rules: {
        sex: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  methods: {
    prepare: function () {
      if (
        this.$props.data &&
        this.$props.data.sex
      ) {
        this.$set(this.form, 'sex', {
          id: '' + (this.$props.data.sex.id ? this.$props.data.sex.id : 'new_sex'),
          content: this.$props.data.sex.content ? this.$props.data.sex.content : ''
        })
      } else {
        this.$set(this.form, 'sex', {
          id: 'new_sex',
          content: ''
        })
      }
    },
    edit: function () {
      this.prepare()
      this.$emit('emit', {
        action: 'edit',
        data: {
          type: 'sex'
        }
      })
    },
    getForm: function () {
      return this.form
    }
  },
  computed: {
    isEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        ['sex', 'all'].includes(this.$props.status.editing)
      )
    },
    isThisEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.status.editing === 'sex'
      )
    },
    isLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        ['sex', 'all'].includes(this.$props.status.loading)
      )
    },
    isThisLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        this.$props.status.loading === 'sex'
      )
    },
    isPrintEmpty () {
      return !(
        this.$props.data &&
        this.$props.data.sex &&
        this.$props.data.sex.content &&
        this.$meta.sex[this.$props.data.sex.content]
      )
    },
    getSexItems () {
      return this.$meta.sex
    },
    printSex () {
      return (
        this.$props.data &&
        this.$props.data.sex &&
        this.$props.data.sex.content &&
        this.$meta.sex[this.$props.data.sex.content]
      ) ? this.$meta.sex[this.$props.data.sex.content] : '性別'
    }
  }
}
</script>
